<template>
    <div class="col-12" v-if="suggestions.length > 0">
        <h3>Most popular sizes for your child's age</h3>
        <div class="col-12 option-suggestions">
            <p class="" v-for="suggestion in limitedSuggestions">
                <span>
                    {{ `${suggestion.popularity}% of customers buy` }}
                </span>
                <span v-if="sizes.length > 1">
                    {{ `size ${suggestion.product_size_name}` }}
                </span>
                <span v-if="colours.length > 1">
                    {{ `colour ${suggestion.product_colour_name}` }}
                </span>
                <span v-if="lengths.length > 1">
                    {{ `length ${suggestion.product_length_name}` }}
                </span>
                <span v-if="flavours.length > 1">
                    {{ `flavour ${suggestion.product_flavour_name}` }}
                </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            limit: 2
        };
    },

    props: {
        suggestions: {
            type: Array
        },
        sizes: {
            type: Array
        },
        colours: {
            type: Array
        },
        lengths: {
            type: Array
        },
        flavours: {
            type: Array
        }
    },
    computed: {
        limitedSuggestions() {
            return this.limit
                ? this.suggestions.slice(0, this.limit)
                : this.suggestions;
        }
    }
};
</script>
